module.exports = __webpack_public_path__ + "static/img/1_QtskibYOKxMA-8ybZxUW6w.6846c50b.jpg";